import type { CSSProperties } from 'react';
import { readableTextColor } from '@forq/platform-data';

/** Standard-Startfarbe im Farbwähler, wenn eine Kachel noch keine eigene Farbe hat. */
export const DEFAULT_TILE_COLOR = '#2563eb';

/**
 * Inline-Style, um eine Kachel ganzflächig einzufärben und dabei Text/Rahmen lesbar zu halten:
 * setzt den Hintergrund und überschreibt die Design-Tokens (Flächen transparent, Text = Kontrastfarbe),
 * damit auch Kacheln, die diese Tokens nutzen (MetricTile & Co.), automatisch mitfärben.
 */
export function tileColorStyle(color: string): CSSProperties {
  const fg = readableTextColor(color);
  const dim = fg === '#ffffff' ? 'rgba(255, 255, 255, 0.74)' : 'rgba(20, 24, 33, 0.7)';
  return {
    background: color,
    borderColor: 'transparent',
    color: fg,
    '--forq-surface': 'transparent',
    '--forq-surface-raised': 'transparent',
    '--forq-surface-hover': 'rgba(255, 255, 255, 0.12)',
    '--forq-border': 'transparent',
    '--forq-border-strong': dim,
    '--forq-text': fg,
    '--forq-text-muted': dim,
    '--forq-text-subtle': dim,
    '--forq-success': fg,
    '--forq-warning': fg,
    '--forq-info': fg,
    '--forq-danger': fg,
  } as CSSProperties;
}
